import { useTypedParams } from '@sorare/routing';

import { RewardsFixtureLeagueQualityRarityPage } from '#src/pages/rewards/RewardsFixtureLeagueQualityRarityPage/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const RewardsPage = () => {
  const { league, quality, rarity } = useTypedParams<PageParams>();
  return (
    <RewardsFixtureLeagueQualityRarityPage
      league={league}
      quality={quality}
      rarity={rarity}
    />
  );
};

export default RewardsPage;
